/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

import {Button, Container, Row, Col} from "reactstrap";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import businessHelper from "../../helpers/BusinessHelper";
import {resource_strings} from "../../translations/resource_translations";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

class ClientHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            student: props.student
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            student: nextProps.student
        });

        if (nextProps.backToClass) {
            this.setState({
                backToClass: nextProps.backToClass
            });
        }

        if (nextProps.backToClassReport) {
            this.setState({
                backToClassReport: nextProps.backToClassReport
            });
        }
    }

    render() {
        this.localize();

        return (
            <>
                <div
                    className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                    style={{
                        minHeight: "500px",
                        backgroundImage: "url(" + businessHelper.backgroundImage("clients") + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "center top"
                    }}
                >
                    {/* Mask */}
                    <span className="mask bg-gradient-dark opacity-8"/>
                    {/* Header container */}
                    <Container className="d-flex align-items-center" fluid>
                        <Row>
                            <Col lg="12" md="10">
                                <h1 className="display-2 text-white">{this.state.student ? this.state.student.name : ""}</h1>
                                <p className="text-white mt-0 mb-5">
                                    {/*This is your profile page. You can see the progress you've*/}
                                    {/*made with your work and manage your projects or assigned tasks*/}
                                    {(this.state.student && this.state.student.note) ? this.state.student.note : ""}
                                </p>
                            </Col>
                            {this.state.student &&
                            <Row style={{alignItems: 'flex-end', marginLeft: 10}}>
                                {this.props.backToClass &&
                                <Button
                                    color="danger"
                                    onClick={e => this.props.goToClass(this.state.backToClass.id)}
                                >
                                    ⬅️ {commonStrings.back_to} {this.state.backToClass.name.substring(0, 20)}
                                </Button>
                                }

                                {this.props.backToClassReport &&
                                <Button
                                    color="danger"
                                    onClick={e => this.props.goToUnpaidReport()}
                                >
                                    ⬅️ {commonStrings.back_to} {commonStrings.navigation.report}
                                </Button>
                                }

                                {this.props.backToUnpaidReport &&
                                <Button
                                    color="danger"
                                    onClick={e => this.props.goToUnpaidReport()}
                                >
                                    ⬅️ {commonStrings.back_to} {commonStrings.navigation.report}
                                </Button>
                                }

                                {this.props.showBackToClientButton &&
                                <Button
                                    className="mt-1"
                                    color="danger"
                                    onClick={(e) => this.props.backToClients(e)}
                                >
                                    ⬅️ {commonStrings.back_to} {commonStrings.navigation.clients}
                                </Button>
                                }

                                <Button
                                    className="mt-1"
                                    color="success"
                                    onClick={e => this.props.manageMembership(e)}
                                >
                                    <img
                                        className="mr-2 ml-0"
                                        width={18}
                                        height={18}
                                        alt="pm"
                                        src={require("assets/img/icons/membership.svg").default}
                                    />
                                    {this.props.student.is_member ? resourceStrings.memberships.cancel : resourceStrings.memberships.add}
                                </Button>

                                {this.state.student &&
                                    <Button
                                        className="mt-1"
                                        color="warning"
                                        onClick={e => this.props.sendEmail(e)}
                                    >
                                    <span className="d-none d-md-block">
                                    <i style={{color: "white", marginRight: 8}} className="fas fa-envelope"/>
                                        {resourceStrings.cabinet.messages}
                                    </span>
                                        <span className="d-md-none">
                                        <i style={{color: "white"}} className="fas fa-envelope"/>
                                    </span>
                                    </Button>
                                }

                                <Button
                                    className="mt-1"
                                    color="info"
                                    onClick={e => this.props.showSendQrModal(e)}
                                >
                                    <span className="d-none d-md-block">
                                    <i style={{color: "white", marginRight: 8}} className="fas fa-qrcode"/>
                                        {commonStrings.send_qr_to_client}
                                    </span>
                                    <span className="d-md-none">
                                        <i style={{color: "white"}} className="fas fa-qrcode"/>
                                    </span>
                                </Button>
                            </Row>
                            }
                        </Row>
                    </Container>
                </div>
            </>
        );
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }
}

export default ClientHeader;
